module.exports = __webpack_public_path__ + "static/media/PTSLogo.7d3b6778.png";